import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import BenchmarkingMedicaidService from "@app/overviews/network-benchmarking-dashboard/benchmarkingMedicaidService";
import { BenchmarkingPrimaryFiltersPayloadType } from "@app/overviews/network-benchmarking-dashboard/filters/shared/benchmarkingPrimaryFiltersPayloadType";
import { MedicaidContractPrimaryFiltersPayload } from "@app/overviews/network-benchmarking-dashboard/medicaid/filters/shared/MedicaidContractPrimaryFiltersPayload";
import { MedicaidNetwork } from "@app/overviews/network-benchmarking-dashboard/medicaid/filters/shared/MedicaidNetwork";

export interface MedicaidContractDetailsResult {
  contractDetails: MedicaidNetwork | undefined;
  isLoading: boolean;
}

export const MEDICAID_CONTRACT_DETAILS_QUERY_KEY_PREFIX = "benchmarking-medicaid-contract";

export const useMedicaidContractDetails = (
  contractId: string | undefined,
  versionId: number | undefined,
  displayedPrimaryFilters: BenchmarkingPrimaryFiltersPayloadType
): MedicaidContractDetailsResult => {
  const benchmarkingMedicaidService = useMemo(() => new BenchmarkingMedicaidService(), []);

  const queryResult = useQuery<MedicaidNetwork>({
    enabled: !!contractId && !!displayedPrimaryFilters,
    queryFn: ({ signal }) => {
      const contractPayload: MedicaidContractPrimaryFiltersPayload = {
        ...displayedPrimaryFilters,
        contractId,
        versionId,
      } as MedicaidContractPrimaryFiltersPayload;
      return benchmarkingMedicaidService.getContractDetails(contractPayload, signal);
    },
    queryKey: [MEDICAID_CONTRACT_DETAILS_QUERY_KEY_PREFIX, contractId, versionId, JSON.stringify(displayedPrimaryFilters)],
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  return {
    contractDetails: queryResult.data,
    isLoading: queryResult.isFetching,
  };
}

export default useMedicaidContractDetails;
